import { mapGetters, mapActions } from 'vuex'
import constants from '@/dependencies/constants'

export default {
  data() {
    return {
      watchedProps: [
        'districts',
        'microDistricts',
        'price',
        'age',
        'gender',
        'outdoor',
        'subwayStations',
        'schedule_ids',
        'page'
      ],
      searchPath: 'location-search-trainers-all'
    }
  },
  computed: {
    ...mapGetters({
      subwayList: 'search/getCommonSubwayList',
      queryParams: 'search/getQueryParameters',
      districtsList: 'search/getCityDistricts',
      sportClub: 'search/searchSportClub',
      sportNames: 'dict/getAllSports',
      isMobile: 'common/getWidth',
      searchSubwayList: 'search/searchSubway',
      resetStatus: 'search/getResetStatus',
      searchPage: 'search/searchPage'
    })
  },
  watch: {
    queryParams: {
      deep: true,
      handler(val) {
        if (this.resetStatus) return

        const chosenData = this.chooseQueryData(val)
        const formedData = this.formatQueryData(chosenData)

        this.$router.push({
          path: '',
          query: { ...formedData }
        })
      }
    }
  },
  async asyncData({ store, params, redirect, app }) {
    const unit = params.pathMatch.split('?')[0].split('/')
    let unitVal = null

    const trainersCached =
      store.getters['search/getCachedTrainers'] &&
      store.getters['search/getCachedTrainers'].length

    if (!store.getters['search/searchLocation']) {
      await store.dispatch('location/LOAD_CITY', { title: params.location })
    }

    try {
      if (params && unit[0]) {
        switch (unit[0]) {
          case 'club': {
            const clubId = unit[1].split('-').pop()

            await store
              .dispatch('search/LOAD_CLUB', clubId)
              .then(async (res) => {
                const {
                  data: { club }
                } = res

                if (unit[1] !== club.url) {
                  await store.dispatch('search/SET_SPORT_CLUB', null)
                  redirect(app.localePath('location-404'))
                }
                unitVal = club
              })

            break
          }
          case 'sport':
            await store.dispatch('dict/LOAD_ALL_SPORTS')
            unitVal = unit[1]
            break
          case '':
            break
          default:
            redirect(app.localePath('location-404'))
        }
      }

      return {
        unit: unit[0] || null,
        unitVal,
        trainersCached
      }
    } catch (e) {
      redirect(app.localePath('location-404'))
      // eslint-disable-next-line no-console
      console.log(e)
    }
  },
  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      // When we do not need to run search logic
      if (vm.unitVal) {
        switch (vm.unit) {
          case 'club':
            vm.unitVal.type = vm.unit
            await vm.setSportClub(vm.unitVal)
            break
          case 'sport':
            await vm.saveSport(vm.unitVal, vm.sportNames)
            break
          default:
            await this.$router.push(this.localePath('location-404'))
        }
      }
      !vm.mobile && vm.setMobile(false)

      await vm.setQueryParamsToStorage(to.query)

      //  don`t load new trainers if there are cached
      // !vm.mobile && !vm.trainersCached && (await vm.loadTrainersList())
      !vm.trainersCached && (await vm.loadTrainersList(vm.searchPage))
    })
  },
  beforeDestroy() {
    this.setResetFiltersStatus(false)
  },
  methods: {
    ...mapActions({
      loadTrainersList: 'search/LOAD_TRAINERS_LIST',
      setAge: 'search/SET_AGE',
      setCost: 'search/SET_COST',
      setGender: 'search/SET_GENDER',
      setOutdoor: 'search/SET_OUTDOOR',
      setSchedule: 'search/SET_SCHEDULE',
      setSubway: 'search/SET_SUBWAY',
      setDistricts: 'search/SET_ALL_DISTRICTS',
      setSportType: 'search/SET_SPORT_TYPE',
      setSportClub: 'search/SET_SPORT_CLUB',
      resetFilters: 'search/RESET_FILTERS',
      setMobile: 'common/SET_WIDTH',
      setResetFiltersStatus: 'search/SET_RESET_FILTERS_STATUS'
    }),
    chooseQueryData(data) {
      return Object.keys(data)
        .filter(
          (key) =>
            this.watchedProps.includes(key) &&
            data[key] &&
            data[key].toString().length
        )
        .reduce((obj, key) => {
          const clearKey = key.replace(/[^a-z]/gi, '')
          return {
            ...obj,
            [clearKey]: data[key]
          }
        }, {})
    },
    ageParse(key, val) {
      return {
        [`${key}-from`]: val.from,
        [`${key}-to`]: val.to
      }
    },
    priceParse(key, val) {
      return {
        [`${key}-from`]: val.from,
        [`${key}-to`]: val.to
      }
    },
    genderParse(key, val) {
      return { [key]: val }
    },
    subwayStationsParse(key, val) {
      return {
        [key]: val.join(',')
      }
    },
    districtsParse(key, val) {
      return {
        [key]: val.join(',')
      }
    },
    microDistrictsParse(key, val) {
      return {
        [key]: val.join(',')
      }
    },
    outdoorParse(key, val) {
      return val && { [key]: val }
    },
    scheduleidsParse(key, val) {
      return {
        [key]: JSON.stringify(val)
      }
    },
    pageParse(key, val) {
      return +val > 1 ? { [key]: val } : {}
    },
    callFunction(functionName, key, val) {
      return this[functionName] && typeof this[functionName] === 'function'
        ? this[functionName](key, val)
        : {}
    },
    formatQueryData(data) {
      return Object.keys(data).reduce((obj, key) => {
        return {
          ...obj,
          ...this.callFunction(`${key}Parse`, key, data[key])
        }
      }, {})
    },
    saveArr(key, data, cb) {
      const prop = key.split('-')[0]

      const defaultFrom = constants.COMMON[`MIN_${prop.toUpperCase()}`]
      const defaultTo = constants.COMMON[`MAX_${prop.toUpperCase()}`]

      const from = parseInt(data[`${prop}-from`])
      const to = parseInt(data[`${prop}-to`])

      const arr = [isNaN(from) ? defaultFrom : from, isNaN(to) ? defaultTo : to]
      cb(arr)
    },
    saveSubway(data) {
      const subwayIds = data.split(',').map((item) => parseInt(item))
      this.setSubway(subwayIds)
    },
    saveDistricts(data) {
      // eslint-disable-next-line no-prototype-builtins
      const districts = data.hasOwnProperty('districts')
        ? data.districts.split(',').map((item) => ({
            id: parseInt(item),
            title: ''
          }))
        : []

      // eslint-disable-next-line no-prototype-builtins
      const microdistricts = data.hasOwnProperty('microDistricts')
        ? data.microDistricts.split(',').map((item) => ({
            id: parseInt(item),
            title: ''
          }))
        : []

      this.setDistricts({
        districts,
        microdistricts
      })
    },
    saveSport(sportName, list) {
      const sportObj = list.find(({ url }) => url === sportName) ?? null
      const unit = 'sport'

      if (sportObj) {
        sportObj.title = sportObj.value
        sportObj.type = unit
        this.setSportType(sportObj)
      } else {
        this.$router.push(this.localePath('location-404'))
      }
    },
    async saveSchedule(schedule) {
      const str = JSON.parse(schedule)
      await this.setSchedule({ schedule: str, scheduleStr: '' })
    },
    setQueryParamsToStorage(params) {
      Object.keys(params).forEach(async (key) => {
        switch (key) {
          case 'districts':
          case 'microDistricts':
            await this.saveDistricts(params)
            break
          case 'subwayStations':
            await this.saveSubway(params[key])
            break
          case 'gender':
            await this.setGender(parseInt(params[key]))
            break
          case 'price-from':
            await this.saveArr(key, params, this.setCost)
            break
          case 'age-from':
            await this.saveArr(key, params, this.setAge)
            break
          case 'outdoor':
            await this.setOutdoor(JSON.parse(params[key]))
            break
          case 'scheduleids':
            await this.saveSchedule(params[key])
            break
          default:
        }
      })
    }
  }
}
